"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.styles = function (_a) {
  var fontFamily = _a.fontFamily,
      fontControl = _a.fontControl,
      sizeBorderRadius = _a.sizeBorderRadius;
  return {
    error: {
      paddingTop: 4
    },
    field: {
      maxWidth: '100%',
      flexGrow: 1,
      fallbacks: [{
        '-ms-flex-positive': '1'
      }, {
        '-webkit-box-flex': '1'
      }, {
        '-webkit-flex-grow': '1'
      }]
    },
    compact: {},
    label: {
      paddingBottom: 2
    }
  };
};